import api from '@/api'

const SET_GROUPS_LIST = 'SET_GROUPS_LIST'

export default {
  namespaced: true,

  state () {
    return {
      groupsList: []
    }
  },

  getters: {
    groupsList: (state) => state.groupsList
  },

  mutations: {
    [SET_GROUPS_LIST] (state, data) {
      state.groupsList = data
    }
  },

  actions: {
    async loadGroupsList ({ commit }, params = {}) {
      const filters = {}
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data } = await api.groups.litelist(filters)
      commit(SET_GROUPS_LIST, data)
      return data
    }
  }
}
